import AmplitudeUtils from '../../../utils/amplitude-utils';
import BaseEnrollPhoneFactorCustomizer from '../base';
export default class EnrollAuthenticatorCustomizer extends BaseEnrollPhoneFactorCustomizer {
  primaryButtonOnClick = () => {
    const { methodType } = this.context;
    const amplitudeEventPrefix = methodType === 'voice' ? 'VoiceCall' : 'SMS';
    AmplitudeUtils.logMfaEnrollEvent(`${amplitudeEventPrefix}::VerifyButtonClick`);
  };

  onInfoContainerLinkClick = () => {
    const { methodType } = this.context;
    const amplitudeEvent = methodType === 'voice' ? 'VoiceCall::RedialButtonClick' : 'SMS::ReSendCodeButtonClick';
    AmplitudeUtils.logMfaEnrollEvent(amplitudeEvent);
  };
  async shouldCustomize() {
    return 'enroll-authenticator' === this.context?.formName && this.context.authenticatorKey === 'phone_number';
  }

  async customize() {
    this.headerDescription = `${this.context.methodType === 'sms'
      ? 'A code was sent to your phone.' : 'Calling your phone.'} Enter the code below to finish setup.`;
    this.onIdxProceed();
    await super.customize();
  }

  protected onIdxProceed() {
    const {
      oktaSignIn: { authClient },
    } = this;
    const originalProceed = authClient.idx.proceed.bind(authClient);
    authClient.idx.proceed = async (...args: any) => {
      const response = await originalProceed.apply(authClient, args);
      if (args[0].step === 'enroll-authenticator' && response.requestDidSucceed) {
        AmplitudeUtils.logMfaEnrollEvent('Phone::Success');
      }
      return response;
    };
  }
}
